import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { Cms, PAGE_TYPES } from '@impact/data';
import { SpotsUiModule } from '../../spots/spots-ui.module';

@Component({
    selector: 'app-new-vehicles-overview-page',
    template: `
        <main>
            <section class="page-grid-content">
                <app-spot-grid [grid]="data?.mainGrid"></app-spot-grid>
            </section>
        </main>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
class NewVehiclesOverviewPageComponent {
    public static ref = PAGE_TYPES.NEW_VEHICLES_OVERVIEW_PAGE;
    @Input() data?: Cms.NewVehiclesOverviewPage;
}



@NgModule({
    declarations: [NewVehiclesOverviewPageComponent],
    imports: [SpotsUiModule]
})
class NewVehiclesOverviewPageModule { }

export const LazyComponent = NewVehiclesOverviewPageComponent;